/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TabType {
  Feed = 'Feed',
  Tasks = 'Tasks',
  KycStatus = 'KycStatus',
  Inbox = 'Inbox',
  TeamMembers = 'TeamMembers',
  Parties = 'Parties',
  Segmentation = 'Segmentation',
  FamilyFriends = 'FamilyFriends',
  ProcessionalConnections = 'ProcessionalConnections',
  Employees = 'Employees',
  Notes = 'Notes',
  Profile = 'Profile',
  Portfolio360 = 'Portfolio360',
  NetworkGraph = 'NetworkGraph',
  CampaignEngagements = 'CampaignEngagements',
  DocumentChecklist = 'DocumentChecklist',
  ExternalUser = 'ExternalUser',
  ClientInsights = 'ClientInsights',
  PendingChanges = 'PendingChanges',
  Edit = 'Edit',
  ExternalTasks = 'ExternalTasks',
  ClientSideDmsSearch = 'ClientSideDmsSearch',
  List = 'List',
  Dashboard = 'Dashboard',
  Appendix = 'Appendix'
}
